// @ts-nocheck
import React from "react";
import DeviceMenu from "./DeviceMenu";
import {
  useDevice,
  useMetrics,
} from "../../../Api/newSockets.api";
import DevicesHeader from "../../../components/Header/DevicesHeader";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import { savePathToLocalStorage } from "../../../utils/helpers";
import { isDeviceSocketLive } from "../../../utils/deviceSocket";
import { DeviceTypeId } from "../../../constants/deviceTypes";
import { Chart } from "chart.js";
import * as Chartjs from "chart.js";

// Import device-specific metrics components
import HostDeviceMetrics from "./HostDeviceMetrics";
import PlcUsbDeviceMetrics from "./PlcUsbDeviceMetrics";
import CameraDeviceMetrics from "./CameraDeviceMetrics";
import RestDeviceMetrics from "./RestDeviceMetrics";

// Register Chart.js components
const controllers = Object.values(Chartjs).filter(
  (chart) => chart.id !== undefined
);
Chart.register(...controllers);

type Props = {
  label?: string;
  icon?: any;
  device?: any;
  match: any;
};

const General = (props: Props) => {
  savePathToLocalStorage();

  const deviceId = props.match.params.deviceId;
  const { getDevice } = useDevice();
  const { device } = getDevice(parseInt(deviceId));
  const { metrics } = useMetrics();

  const currentDeviceId = Number.parseInt(deviceId, 10);

  // Check device types
  const isHostDevice = device?.deviceTypes?.id === DeviceTypeId.HOST;
  const isPlcDevice = device?.deviceTypes?.id === DeviceTypeId.PLC;
  const isUsbDevice = device?.deviceTypes?.id === DeviceTypeId.USB;
  const isCameraDevice = device?.deviceTypes?.id === DeviceTypeId.CAMERA;
  const isRestDevice = device?.deviceTypes?.id === DeviceTypeId.REST;
  const isPlcOrUsb = isPlcDevice || isUsbDevice;

  const isOnline = isDeviceSocketLive(device);

  return device ? (
    <div className="device-main main-content" style={{ overflowX: "hidden", minWidth: 0 }}>
      <DevicesHeader device={device} />
      <div className="general-body-content">
        <div>
          <DeviceMenu typeId={device.deviceTypes.id} />
        </div>
        <div className="general" style={{ paddingLeft: "1.5rem", paddingRight: "1.5rem", maxWidth: "100%", minWidth: 0, overflow: "hidden" }}>
          {/* Device-specific metrics sections */}
          {isPlcOrUsb && (
            <PlcUsbDeviceMetrics
              device={device}
              deviceId={currentDeviceId}
              metrics={metrics}
              isOnline={isOnline}
            />
          )}

          {isHostDevice && (
            <HostDeviceMetrics
              device={device}
              deviceId={currentDeviceId}
              metrics={metrics}
              isOnline={isOnline}
            />
          )}

          {isCameraDevice && (
            <CameraDeviceMetrics
              device={device}
              deviceId={currentDeviceId}
              isOnline={isOnline}
            />
          )}

          {isRestDevice && (
            <RestDeviceMetrics
              device={device}
              deviceId={currentDeviceId}
              metrics={metrics}
              isOnline={isOnline}
            />
          )}
        </div>
      </div>
    </div>
  ) : (
    <LoadingSpinner />
  );
};

export default General;
